import { getMachineStructureNodeset } from "@src/cloud-connect/dependency-injection-container/get-machine-structure-nodeset";
import { getNodeManager } from "@src/cloud-connect/dependency-injection-container/get-node-manager";
import { OurNode } from "@src/cloud-connect/poc/our-node";
import { warningSnackbar } from "@src/cloud-connect/snackbars/entities/snackbar-launcher";
import { useI18N } from "@src/language/language-context";
import {
  updateNodeSelectionNodeEditedState,
  updateStructureWasSaved,
} from "@src/reducers/your-reducer";
import { useEffect, useState } from "react";
import { useDispatch } from "react-redux";

export const useNameInputOurNodeHook = (nodeId, inputRef) => {
  const dispatch = useDispatch();
  const i18n = useI18N();

  const [nodeInputValue, setNodeInputValue] = useState("");

  const texts = {
    warningNoEmptyNodeName: i18n("modules.nameOurNode.warningNoEmptyNodeName"),
    warningNoEmptyFolderName: i18n(
      "modules.nameOurNode.warningNoEmptyFolderName",
    ),
  };

  const handleSaveModifiedNodeName = (node: OurNode) => {
    const nodeManager = getNodeManager();

    if (nodeInputValue.trim() === "") {
      if (node.node_type === "FOLDER") {
        warningSnackbar(texts.warningNoEmptyFolderName);
      } else {
        warningSnackbar(texts.warningNoEmptyNodeName);
      }
    } else {
      nodeManager.getSaveNodeNameHandler().saveNodeName(node, nodeInputValue);
      dispatch(updateNodeSelectionNodeEditedState(false));
      dispatch(updateStructureWasSaved(false));
    }
  };

  useEffect(() => {
    const inputElement = inputRef.current;

    if (inputElement) {
      const keepFocus = () => {
        setTimeout(() => {
          // setTimeout is needed to avoid conflicts with other focusable elements
          if (document.activeElement !== inputElement) {
            inputElement.focus(); // Ensure the input remains focused until rendered
          }
        }, 0); // 0ms delay means it's placed on the next event loop
      };

      // Attach blur event listener to keep focus
      inputElement.addEventListener("blur", keepFocus);

      // Cleanup function to remove the event listener when the component unmounts
      return () => {
        inputElement.removeEventListener("blur", keepFocus);
      };
    }
  }, [inputRef]);

  useEffect(() => {
    const node = getMachineStructureNodeset().getFlatMap().get(nodeId);
    setNodeInputValue(node.name);
  }, [nodeId]);

  return { nodeInputValue, setNodeInputValue, handleSaveModifiedNodeName };
};
